import React, {Component} from 'react';
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {withFirestore, firestoreConnect, isLoaded} from "react-redux-firebase";
import {connect} from "react-redux";
import {UserIsAuthenticated} from "../../utils/AuthManager";
import {StyledButton} from "../../components/Buttons";
import {CALL_DB_PATH} from "../../constants/DB_PATHS";
import {BackgroundDiv} from "../../components/Containers";
import Navbar from "../../components/Navbar";
import CallListItem from "../../components/CallListItem";
import withMyCoordsHOC from "../../components/MyCoordsHOC";
import TableOneUserAll from "../../components/TableQueries/TableOneUserALL";
import BasicTablePage from "../../components/TableQueries/BasicTablePage";

class MyCalls extends Component {


    /*componentWillMount() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                async position => {
                    this.setState({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    })
                }, error => {
                    console.log('pos error')

                }
            )
        } else {
            console.log('no navigator')

        }
    }*/


    render() {
        return (
            <div>
                <BasicTablePage
                    header={'Hivasaim'}
                    queryWhere={[
                        ['takenBy', '==', this.props.auth.uid],
                    ]}
                />

            </div>
        );
    }
}

export default compose(
    connect(
        ({firebase: {auth, profile}}) => ({
            auth,
            profile,
        })
    ),
    /*withRouter,
    withFirestore,

    UserIsAuthenticated,
    connect((state, props) => ({
        myCalls: state.firestore.ordered.myCalls
    })),
    firestoreConnect(props => {
            return [{
                collection: CALL_DB_PATH,
                where: [
                    ['takenBy', '==', props.auth.uid],
                ],
                orderBy: [
                    ['callDate', 'desc'],
                ],
                storeAs: 'myCalls'
            }]
        }
    ),
    withMyCoordsHOC*/
)(MyCalls);